const getUrlDomain = (url) => {
  if (!url) return null;
  const regex = /^(https?:\/\/[^/]+)/;
  const matches = url.match(regex);
  return matches[0];
};

export default getUrlDomain;
